import {QueryClient, QueryClientProvider} from "react-query";
import UnavailabilityFormPage from "./UnavailabilityFormPage";

import React from "react";
import Box from "@mui/material/Box";


export function DashboardOverviewUnavailabilityFormPage() {
    const queryClient = new QueryClient();

    return (
        <QueryClientProvider client={queryClient}>
            <Box sx={{
                marginTop: 1,
                marginRight: 3
            }}>
                <UnavailabilityFormPage />
            </Box>
        </QueryClientProvider>
    );
}